import {
  buildMedicationPosologyForm,
  extractNoteText,
} from "./editHydrationHelpers";

/**
 * Converte MedicationRequest FHIR → item de intervenção (shape básico).
 * Tarja/apresentação/CMED são completados depois por enrichMedicationInterventionFromCmed.
 *
 * Limitação: type default "medication" — MR atual não distingue supplement/herbal.
 */
export function mapMedicationRequestToIntervention(medicationRequest: any) {
  const concept = medicationRequest?.medication?.concept;
  const medicationName = concept?.text || "";
  const coding = concept?.coding?.[0];

  const dosageInstruction = medicationRequest?.dosageInstruction?.[0];
  const doseAndRate = dosageInstruction?.doseAndRate?.[0];
  const doseQuantity = doseAndRate?.doseQuantity;
  const timing = dosageInstruction?.timing?.repeat;

  const noteText = extractNoteText(medicationRequest?.note);
  const intervalHours = timing?.period;
  const durationDays = timing?.duration;

  const quantityValue = doseQuantity?.value;
  // Forma = type.text (como PrescriptionCare / generateItem) — não usar unit como fallback
  // para não duplicar no `form` do PDF ("1 Comprimido Comprimido").
  const formLabel = doseAndRate?.type?.text || "";

  // Posologia do PDF alinhada ao prontuário (evita "Modo de Usar" indevido / texto diferente)
  const auxForm = buildMedicationPosologyForm(medicationRequest);

  // Placeholder até o enrich CMED; sem code permanece Branca
  const tag = "Branca";
  const label = medicationName?.trim() || "Medicamento";

  return {
    name: medicationName,
    label,
    inputValue: {
      ...(coding && {
        code: {
          coding: [
            {
              code: coding?.code,
              display: coding?.display,
              system:
                coding?.system ||
                "https://fluxmed.com.br/fhir/CodeSystem/CMED",
            },
          ],
        },
        tag,
      }),
      name: medicationName,
      label,
    },
    tag,
    ...(quantityValue !== undefined &&
      quantityValue !== null && {
        quantity: { label: `${quantityValue}`, value: quantityValue },
      }),
    ...(intervalHours != null && {
      frequency: { label: `${intervalHours} h`, value: intervalHours },
    }),
    formValue: { label: formLabel },
    ...(durationDays != null && {
      time: { label: `${durationDays} dias`, value: durationDays },
    }),
    note: noteText,
    form: auxForm,
    type: "medication",
    ...(coding && {
      code: {
        coding: [
          {
            code: coding?.code,
            display: coding?.display,
            system:
              coding?.system || "https://fluxmed.com.br/fhir/CodeSystem/CMED",
          },
        ],
      },
    }),
    tabValue: "0",
    fromEditHydration: true,
    medicationRequestId: medicationRequest?.id,
    // Preserva agrupamento do lote para PUT (não regenerar groupIdentifier)
    ...(medicationRequest?.groupIdentifier && {
      groupIdentifier: medicationRequest.groupIdentifier,
    }),
    ...(medicationRequest?.identifier && {
      identifier: medicationRequest.identifier,
    }),
  };
}
